import { adt, gpAdt } from '@/util/useData'
import { getServfee } from '@/apis/shopcart'
import { AdtCfgList, getShopLogistics } from '@/apis/setup'
import { isD2C } from '@/store'

const adtMapP = () =>
  adt().then((res) => {
    return (res.productAdditionList ?? []).reduce((map: any, v: any) => {
      map[v.additionConfigId] = v
      return map
    }, {})
  })

interface ADT {
  additionConfigId: number;
  ingredientsSku?: string;
}
interface Sku {
  buyQuantity: number;
  orderQuantity?: number;
  totalPrice: number;
  cartAdditionList?: ADT[];
  combinationProductAdditionList?: ADT[];
}

const rule: any = {
  '-1': () => 0,
  1: (item: Sku, adt: any) => adt.cost * item.buyQuantity,
  3: (item: Sku, adt: any) => (adt.cost / 100) * item.totalPrice,
  5: (item: Sku, adt: any) => adt.cost,
  10: (item: Sku, adt: any) => adt.cost * (item.buyQuantity ? 1 : 0)
}

async function calc (item: Sku, MapP: Promise<any>) {
  const map = await MapP
  return (item.cartAdditionList ?? []).reduce((acc, v) => {
    const cfg = { ...map[v.additionConfigId], ...v }
    return acc + rule[cfg.calculateConfigId ?? '-1'](item, cfg)
  }, 0)
}

// 计算附加项费
export const calcAdt = (item: Sku): Promise<number> => {
  return calc(item, adtMapP())
}

// 计算组合商品附加项费
export const calcGpAdt = (item: Sku): Promise<number> => {
  const gp = gpAdt().then((res) => {
    return (res.productAdditionList ?? []).reduce((map: any, v: any) => {
      map[v.additionConfigId] = v
      return map
    }, {})
  })
  const t = {
    ...item,
    buyQuantity: item.orderQuantity || 0,
    cartAdditionList: item.combinationProductAdditionList
  }
  return calc(t, gp)
}

// 计算手续费
export const calcSer = (item: Sku, channel: number): Promise<number> => {
  const mapP = getServfee(channel).then((res) => {
    // 这里套用模板数据结构
    item.cartAdditionList = res.data
    return (res.data ?? []).reduce((map: any, v: any) => {
      map[v.additionConfigId] = v
      return map
    }, {})
  })
  return calc(item, mapP)
}

// 商品加购前查询对应类目附加项
export const setAdt = (() => {
  let req: any = null
  return async (
    cateId: string,
    listName = 'cartAdditionList',
    flagName = 'noAdditionalFlag'
  ): Promise<any> => {
    let data: any = []
    if (!req) {
      req = AdtCfgList().then((res) => {
        req = null
        return res
      })
    }
    await req.then((res: any) => {
      if (res.success) {
        res.data.forEach((v: any) => {
          if (v.additionScene === 0 && !data.length) {
            data = v.noAdditionalFlag || v.additionItemList
          } else if (v.additionScene === 1 && v.categoryAdditionList) {
            if (!v.categoryAdditionList) return
            v.categoryAdditionList.forEach((v2: any) => {
              if (v2.categoryStaus && v2.categoryCateId === cateId) {
                data = v.noAdditionalFlag || v.additionItemList
              }
            })
          }
        })
      }
    })
    return {
      [flagName]: data === 1 ? 1 : 0,
      [listName]: data === 1 ? [] : data
    }
  }
})()

// 加购前获取默认发货附加项
export const getDeli = (): any =>
  getShopLogistics().then(async (res) => {
    console.log(res)
    if (res.success) {
      const adtRes = await adt().then((data) => {
        return data.deliveryAdditionList.map((v: any) => {
          const t = { ...v }
          return t
        })
      })
      const data = res.data.additionItemList ?? []
      const arr = adtRes.filter((v: any) => data.find((v2: any) => v2.additionId === v.additionId))
      const dft = adtRes.filter((v: any) => v.additionId === (isD2C() ? 42 : 23))
      return arr?.length ? arr : dft
    }
  })

export const getAdt = async (list: any, type: any): Promise<any> => {
  list = list ?? []
  const adtRes = await adt().then((data) => {
    return data[type ? 'deliveryAdditionList' : 'productAdditionList'].map((v: any) => {
      const f = list.find((v2: any) => v2.additionId === v.additionId)
      if (f) {
        return { ...f, ...v }
      } else {
        return false
      }
    })
  })
  const arr = adtRes.filter((v: any) => v)
  return arr
}
